import { useTranslation } from 'react-i18next';

interface FooterProps {
  newsletterFormUrl: string;
}

export default function Footer({ newsletterFormUrl }: FooterProps) {
  const { t } = useTranslation();

  return (
    <footer className="bg-[#1a1a1a] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-1 gap-8 mb-12">
          <div>
            <h4 className="text-lg font-semibold mb-4">{t('footer.contact')}</h4>
            <ul className="space-y-2 text-gray-400">
              <li className="flex items-start">
                <i className="ri-phone-line mt-1 mr-2"></i>
                <a href="tel:+17272036714" className="hover:text-white transition-colors cursor-pointer underline">1 (727) 203-6714</a>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-line mt-1 mr-2"></i>
                <a href="mailto:sunroutegroup@gmail.com" className="hover:text-white transition-colors cursor-pointer">sunroutegroup@gmail.com</a>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-line mt-1 mr-2"></i>
                <a href="https://www.google.com/maps/place/Florida,+USA" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">Florida, USA</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col items-center text-center">
            <div className="flex space-x-6 mb-4">
              <a href="https://www.instagram.com/sunroutegroup" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-2xl"></i>
              </a>
              <a href="https://www.facebook.com/share/1B1H6GYJJa/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-2xl"></i>
              </a>
              <a href="https://wa.me/17272036714" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-whatsapp-fill text-2xl"></i>
              </a>
            </div>
            <p className="text-gray-400 text-sm">
              © 2026 SunRoute Group. {t('footer.rights')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
